import { s3URL } from '@mathflat/common/util'

import S from './EmptyList.style'

const 새알림없음 = () => {
  return (
    <S.EmptyList>
      <img
        className="empty-notification-image"
        src={s3URL.mathflatAssetsBucket.teacher('assets/images/notification/bell_shadow@3x.png')}
        alt="no-notification"
      />
      <p className="empty-notification-text">아직 알림이 없어요.</p>
    </S.EmptyList>
  )
}

export default 새알림없음
